<template>
  <div class="est-modal-host">
    <DynamicBootstrapModal v-if="visible"
                           :key="openId"
                           :component="component"
                           :componentProps="boundProps"
                           :options="options"
                           @onClose="handleClose" />
  </div>
</template>

<script>
  /* Estesoft.App ModalHost'un Vega uyarlaması: bus mitt adaptöründen,
     onOpen/onClose alt bileşene prop olarak geçmez, kapatma geri çağrısı bir kez çalışır
     (clientapp handleClose'da iki kez çağırıyordu), kapalıyken close() yok sayılır.
     App.vue'da <Teleport to="body"> ile document.body'nin sonuna taşınır. */
  import { bus } from '../../../plugins/event-bus';
  import DynamicBootstrapModal from './DynamicBootstrapModal.vue';
  import { markRaw } from 'vue';

  export default {
    name: 'ModalHost',
    components: { DynamicBootstrapModal },
    data() {
      return {
        visible: false,
        openId: 0,
        component: null,
        props: {},
        options: {}
      };
    },
    computed: {
      boundProps() {
        // eslint-disable-next-line no-unused-vars
        const { onOpen, onClose, ...rest } = this.props || {};
        return rest;
      }
    },
    mounted() {
      bus.$on("show-modal", this.openModal);
      bus.$on("close-modal", this.closeModal);
    },
    beforeUnmount() {
      bus.$off("show-modal", this.openModal);
      bus.$off("close-modal", this.closeModal);
    },
    methods: {
      openModal({ component, props, options }) {
        props = props || {};

        if (props.onOpen && typeof props.onOpen === "function") {
          props.onOpen();
        }

        this.component = component && typeof component === "object" ? markRaw(component) : component;
        this.props = props;
        this.options = options || {};
        this.openId += 1;
        this.visible = true;
      },
      closeModal(params) {
        if (!this.visible) return;

        const onClose = this.props.onClose;
        this.visible = false;
        this.component = null;
        this.props = {};

        if (onClose && typeof onClose === "function") {
          onClose(params);
        }
      },
      handleClose() {
        this.closeModal();
      },
    },
  };
</script>
